import { render, staticRenderFns } from "./AddStudentClass.vue?vue&type=template&id=201874e7&scoped=true"
import script from "./AddStudentClass.vue?vue&type=script&lang=js"
export * from "./AddStudentClass.vue?vue&type=script&lang=js"
import style0 from "./AddStudentClass.vue?vue&type=style&index=0&id=201874e7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "201874e7",
  null
  
)

export default component.exports